import React from "react";
import {
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  ModalProps,
  Modal as CharkaModal,
} from "@chakra-ui/react";

interface MyModalProps extends ModalProps {
  title: string;
  submitBtnText?: string;
  cancelBtnText?: string;
  disableSubmit?: boolean;
  loadingSubmit?: boolean;
  onSubmit?: () => void;
  submitBtnWidth?: string;
  cancelBtnWidth?: string;
  disabledCloseOutSide?: boolean;
}
const MyModal = (props: MyModalProps) => {
  const {
    title,
    onClose,
    children,
    onSubmit,
    submitBtnText,
    loadingSubmit,
    disableSubmit,
    cancelBtnText,
    disabledCloseOutSide,
    submitBtnWidth,
    cancelBtnWidth,
  } = props;

  return (
    <CharkaModal
      {...props}
      trapFocus={false}
      onClose={disabledCloseOutSide ? () => { } : onClose}
    >
      <ModalOverlay data-testid="modal-overlay" />
      <ModalContent>
        <ModalHeader
          padding="32px 32px 4px 32px"
          marginTop="8px"
          className="capitalize"
        >
          {title}
        </ModalHeader>
        <ModalCloseButton
          data-testid="crud-modal-close"
          onClick={onClose}
          marginTop="4px"
          sx={{ _focus: { outline: "none", boxShadow: "none" } }}
        />
        <ModalBody padding={"32px"}>{children}</ModalBody>

        <ModalFooter padding="0 32px 32px">
          <Button
            data-testid="modal-cancel-btn"
            variant="outline"
            mr={3}
            onClick={onClose}
            minW={cancelBtnWidth || "96px"}
            disabled={loadingSubmit}
          >
            {cancelBtnText || "Close"}
          </Button>
          {onSubmit && (
            <Button
              data-testid="modal-submit-btn"
              isLoading={loadingSubmit}
              disabled={disableSubmit || loadingSubmit}
              colorScheme="blue"
              type="submit"
              onClick={onSubmit}
              minW={submitBtnWidth || "96px"}
            >
              {submitBtnText || "Submit"}
            </Button>
          )}
        </ModalFooter>
      </ModalContent>
    </CharkaModal>
  );
};

export default MyModal;
